import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ProjectInfo } from '@app/shared/models/project-info.model';
import { ApiPaths } from '@app/feature/main/roles-shared/services/api-path';

@Injectable()

export class CreateProjectService {

  public filterType;
  public selectedServiceProvider;
  public projectFormData: ProjectInfo;
  public selectedOfferings;

  // Flags
  public restoreSPSelection: boolean;
  public isStepperModeActive: boolean;

  // Redirect URL
  public redirectUrl = '/';

  // Observables
  public resetProgress = new Subject();
  public isFormSubmitted = new Subject();
  public ispartnerAssigned = new Subject();
  public isLaunchProjectBackClicked = new Subject();
  public isAssignPartnerBackClicked = new Subject();


  constructor(private httpClient: HttpClient) {
    this.restoreSPSelection = true;
    this.isStepperModeActive = true;
  }

  constructURLSearchParams(params) {
    let formattedParamString = '';
    for (const prop in params) {
      if (params.hasOwnProperty(prop)) {
        formattedParamString += '?' + prop + '=' + params[prop];
      }
    }
    return formattedParamString;
  }

  //  -- FLAGS SETTING METHODS --

  setStepperMode() {
    this.isStepperModeActive = true;
  }

  getStepperModeStatus() {
    return this.isStepperModeActive;
  }

  setNormalMode() {
    this.isStepperModeActive = false;
  }

  backButtonClickOnAssignPartner() {
    this.isAssignPartnerBackClicked.next();
  }

  getAssignPartnerBackBtnStatus() {
    return this.isAssignPartnerBackClicked.asObservable();
  }

  backButtonClickOnLaunchProject() {
    this.isLaunchProjectBackClicked.next();
  }

  getLaunchProjectBtnStatus() {
    return this.isLaunchProjectBackClicked.asObservable();
  }

  triggerPartnerAssignment() {
    this.ispartnerAssigned.next(true);
  }

  getPartnerAssignmentStatus() {
    return this.ispartnerAssigned.asObservable();
  }

  triggerFormSubmission() {
    this.isFormSubmitted.next(true);
  }

  getformSubmissionStatus() {
    return this.isFormSubmitted.asObservable();
  }

  getResetStatus() {
    return this.resetProgress.asObservable();
  }

  // -- DATA BINDING METHODS --

  getRedirectUrl() {
    return this.redirectUrl;
  }

  setRedirectUrl(url) {
    this.redirectUrl = url;
  }

  setProjectFormData(projectData) {
    this.projectFormData = projectData;
  }

  getProjectFormData() {
    return this.projectFormData;
  }

  clearServiceProviderInfo() {
    this.selectedServiceProvider = null;
  }

  setServiceProviderInfo(spData) {
    this.selectedServiceProvider = spData;
  }

  getServiceProviderInfo() {
    return this.selectedServiceProvider;
  }

  getAccountType() {
    return this.filterType;
  }

  setAccountType(filterType) {
    this.filterType = filterType;
  }


  // -- DATA RESET METHODS --
  resetStoredValues() {
    this.filterType = null;
    this.redirectUrl = null;
    this.projectFormData = null;
    this.isStepperModeActive = true;
    this.selectedServiceProvider = null;
    this.selectedOfferings =null;
    this.resetProgress.next();
  }

  // -- API CALL METHODS --
  getServiceLinesList(params): Observable<any> {
    const formattedParamString = this.constructURLSearchParams(params);
    const path = ApiPaths.myProjects.getServiceLines + formattedParamString;
    return this.httpClient.get(path);
  }

  getServiceList(filter: any) {
    return this.httpClient.get("Services", { params: filter });
  }
  getMarketList(filter: any) {
    return this.httpClient.get("Markets", { params: filter });
  }

  getAvailableAnalystMarketList() {
    return this.httpClient.get("Markets/getAvailableAnalystMarkets");
  }

  getFocusAreaList(filter: any) {
    return this.httpClient.get("FocusAreas", { params: filter });
  }
  getIndustryList(filter: any) {
    return this.httpClient.get("Industries", { params: filter });
  }

  getCompanyInfo(): Observable<any> {
    const path = `/profiles/get-company-info`;
    return this.httpClient.get(path);
  }

  getServiceLines(): Observable<any> {
    const path = `/profiles/get-expertise`;
    return this.httpClient.get(path);
  }
  
  getProjectType(): Observable<any> {
    return this.httpClient.get('project-types');
  }

  getSelectedServiceInfo(params): Observable<any> {
    const path = ApiPaths.myProjects.getSelectedProviderInfo;
    return this.httpClient.post(path, params);
  }

  getClientDetails(data) {
    const path = `/users/client-search?search=${data.search}&limit=${data.limit}&skip=${data.skip}`;
    return this.httpClient.get(path);

  }
  saveProject(params): Observable<any> {
    return this.httpClient.post('projects', params);
  }

  setSelectedOfferings(offerings) {
    this.selectedOfferings = offerings;
  }

  getSelectedOfferings() {
    return this.selectedOfferings;
  }

  uploadDocument(formData, fileType, fileName): Observable<any> {
    const headerInfo = new HttpHeaders({ 'Content-Type': 'multipart/form-data;'});
    const options = { headers: headerInfo };
    return this.httpClient.post(`projects/upload?fileType=${fileType}&fileName=${fileName}`, formData, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/create-project/create-project.service.ts